import store from "../../../core/store";

export const enableAutosave = (form) => {
    return store.dispatch({
        type: "general.autosave/ENABLE_AUTOSAVE",
        form
    });
};